import { c as _c } from "react/compiler-runtime";
import React from 'react';
import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import MobileProductFilters from './MobileProductFilters';
import MobileProductListingColorFilter from './MobileProductListingColorFilter';
import ProductClearAllFiltersButton from './ProductClearAllFiltersButton';
const MobileProductFiltersModal = t0 => {
  const $ = _c(26);
  const {
    activeFilterCount,
    isOpen,
    onClose,
    productsCount,
    items,
    refine,
    canClear,
    clearRefinement,
    colorFilters,
    refineColorFilters
  } = t0;
  const {
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t1;
  if ($[0] !== canClear || $[1] !== clearRefinement) {
    t1 = <ProductClearAllFiltersButton canClear={canClear} clearRefinement={clearRefinement} />;
    $[0] = canClear;
    $[1] = clearRefinement;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = productsCount || 0;
  const t3 = productsCount === 1 ? "" : "s";
  let t4;
  if ($[3] !== onClose || $[4] !== t2 || $[5] !== t3) {
    t4 = <CtaButton block={true} onClick={onClose}>Done ({t2} result{t3})</CtaButton>;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters";
  let t6;
  if ($[7] !== handleToggleReadyToShip || $[8] !== isReadyToShipActive) {
    t6 = <div className="mb-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} showLabelOnMobile={true} /></div>;
    $[7] = handleToggleReadyToShip;
    $[8] = isReadyToShipActive;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mb-4"><WidthRangeFilter showTitle={true} /></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== colorFilters || $[12] !== refineColorFilters) {
    t8 = <div className="mb-4"><MobileProductListingColorFilter colorFilters={colorFilters} refineColorFilters={refineColorFilters} /></div>;
    $[11] = colorFilters;
    $[12] = refineColorFilters;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== items || $[15] !== refine) {
    t9 = <MobileProductFilters items={items} refine={refine} />;
    $[14] = items;
    $[15] = refine;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== isOpen || $[18] !== onClose || $[19] !== t1 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t10 = <MobileOnly><div className="md:hidden"><MobileModal enableHashHistory={false} headerRight={t1} isFullHeight={true} isOpen={isOpen} onClose={onClose} stickyFooter={t4} title={t5}>{t6}{t7}{t8}{t9}</MobileModal></div></MobileOnly>;
    $[17] = isOpen;
    $[18] = onClose;
    $[19] = t1;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default MobileProductFiltersModal;